"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.TrackingTargetProviderEnum = void 0;
var TrackingTargetProviderEnum;
(function (TrackingTargetProviderEnum) {
    TrackingTargetProviderEnum["GOOGLE_ANALYTICS"] = "google-analytics";
    TrackingTargetProviderEnum["GTM"] = "gtm";
    TrackingTargetProviderEnum["FACEBOOK_PIXEL"] = "facebook-pixel";
    TrackingTargetProviderEnum["FACEBOOK_CONVERSION"] = "facebook-conversion";
    TrackingTargetProviderEnum["HOTJAR"] = "";
    TrackingTargetProviderEnum["CDP"] = "cdp";
})(TrackingTargetProviderEnum || (exports.TrackingTargetProviderEnum = TrackingTargetProviderEnum = {}));
